import { useEffect } from "react";

export function useStatusReset(status, setStatus, delay = 2000) {
  useEffect(() => {
    if (!status) return;

    const timer = setTimeout(() => {
      setStatus("");
    }, delay);

    return () => clearTimeout(timer);
  }, [status, setStatus, delay]);
}
